import { Component, EventEmitter, Input, OnChanges, OnInit, Output, TemplateRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { filter, map, mergeMap, take } from 'rxjs/operators';
import { AccountService } from 'src/app/services/account.service';
import { EthWalletService, Status } from 'src/app/services/eth-wallet.service';
import { SelectWalletComponent } from '../select-wallet/select-wallet.component';
import { Observable, combineLatest } from 'rxjs';
import { sharePublishReplay } from 'ngx-libs';
import { Network } from 'src/app/services/configuration';

@Component({
  selector: 'app-connect-button',
  templateUrl: './connect-button.component.html',
  styleUrls: ['./connect-button.component.scss']
})
export class ConnectButtonComponent implements OnInit, OnChanges {
  @Input() btnClass = 'btn btn-primary';
  @Input() targetNetwork: Network;
  @Input() switchText = 'Switch Network';
  @Input() connectWalletTemplate: TemplateRef<any>;
  @Input() switchNetworkTemplate: TemplateRef<any>;
  @Output() connected = new EventEmitter();

  chainMatched: Observable<boolean>;

  constructor(
    public accountService: AccountService,
    public ethWalletService: EthWalletService,
    private ngbModal: NgbModal
  ) { }

  ngOnInit(): void {
    this.ngOnChanges();
  }

  ngOnChanges() {
    if (this.targetNetwork) {
      this.chainMatched = combineLatest([this.ethWalletService.status, this.ethWalletService.chainId]).pipe(
        map(([s, chainId]) => s !== Status.Connected || parseInt(this.targetNetwork.params.chainId, 16) === chainId),
        sharePublishReplay(1)
      );
    } else {
      this.chainMatched = this.ethWalletService.chainMatched;
    }
  }

  connect() {
    const ref = this.ngbModal.open(SelectWalletComponent, {
      size: 'sm',
      centered: true
    });
    ref.closed.pipe(
      filter((r) => r),
      mergeMap(() => this.ethWalletService.selectedNetwork),
      take(1)
    ).subscribe((network) => {
      setTimeout(() => this.changeWalletNetwork(network), 100);
    });
  }

  switchNetwork() {
    if (this.targetNetwork) {
      this.changeWalletNetwork(this.targetNetwork);
    } else {
      this.ethWalletService.selectedNetwork.pipe(
        take(1)
      ).subscribe((network) => {
        this.changeWalletNetwork(network);
      });
    }
  }

  changeWalletNetwork(network: any) {
    this.ethWalletService.status.pipe(
      take(1),
      filter((s) => s === Status.Connected),
      mergeMap(() => this.ethWalletService.switchEthereumChain([{ chainId: network.params.chainId} ])),
    ).subscribe(() => {
      this.connected.next();
    }, (error) => {
      if (error.code === 4902) {
        this.ethWalletService.addEthereumChain([network.params]).subscribe(() => {
          this.connected.next();
        });
      }
    });
  }
}
